export const headers = [
  { content: "" },
  { content: "Member" },
  { content: "Role" },
  { content: "User Type" },
  { content: "Property" },
  { content: "Inncode" }
];
